// extracted by mini-css-extract-plugin
module.exports = {"container":"_3eAjg","vertical":"S94bD","size_l":"_2synI"};